import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from 'atoms/button';
import Icon from 'atoms/icon';
import { InfoBlock } from 'organisms/InfoBlock';

import EditInfoModal from '../modals/EditInfoModal';
import ProviderHours from './ProviderHours';
import ProviderInformation from './ProviderInformation';
import ProviderTitle from './ProviderTitle';

export default function ProfileInfoBar({ isMyProvider, provider }) {
  const navigate = useNavigate();
  const [isOpen, openModal] = useState(false);
  const { inviteCode, locations, userList, slug } = provider;
  const { hours } = locations[0];
  const { isAdmin } = useSelector((state) => state.user);

  const hasUser = userList?.length;

  const onEditInformation = () => {
    openModal(true);
  };

  const onCreateTeamUserAccount = () => {
    sessionStorage.setItem('inviteCode', inviteCode);
    sessionStorage.setItem('inviteCodeProvider', slug);
    navigate(`/signup`);
  };

  return (
    <InfoBlock>
      <div className="profile-info">
        <ProviderTitle isMyProvider={isMyProvider} provider={provider} />

        <div className="profile-info-details mb-24">
          <ProviderInformation location={locations[0]} />

          <span className="flex-row align-start hours mt-24">
            <Icon name="clock" className="ml-2 mr-20" />
            <ProviderHours hours={hours} />
          </span>
        </div>
        {isMyProvider && (
          <Button
            onClick={onEditInformation}
            size="medium"
            className="ml-35 mb-100"
            variant="reverse"
            text="Edit information"
          />
        )}
        {isAdmin && !hasUser && (
          <Button
            onClick={onCreateTeamUserAccount}
            size="medium"
            className="ml-35 mb-35"
            variant={inviteCode ? 'reverse' : 'reverse-disabled'}
            text={inviteCode ? 'Create user account' : 'No invite code'}
          />
        )}
      </div>
      {isOpen && <EditInfoModal isOpen={isOpen} openModal={openModal} />}
    </InfoBlock>
  );
}
